import { render, staticRenderFns } from "./qixiFestivel.vue?vue&type=template&id=83203e96&"
import script from "./qixiFestivel.vue?vue&type=script&lang=js&"
export * from "./qixiFestivel.vue?vue&type=script&lang=js&"
import style0 from "./qixiFestivel.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports